<template>
  <section>
    <h1>Not Found</h1>
    <p><a href="#/home">Home</a></p>
  </section>
</template>

<script>
export default {
  name: 'not_found',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/NotFound.vue